// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3exOW","info":"PatientInfo_info__16xhC"};